import { useEffect } from "react";
import { motion } from "framer-motion";
import { IconButton, Paper, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const InstructionTooltip = ({ instruction, duration = 8000, onClose }) => {
  const { isShow, position, message } = instruction;
  useEffect(() => {
    if (isShow) {
      const timer = setTimeout(() => {
        onClose && onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isShow, duration, onClose]);

  if (!isShow) return null;

  const tooltipStyles = {
    position: "absolute",
    zIndex: 1000,
    padding: "8px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    transformOrigin: "center",
    ...position,
  };

  // Static arrow always pointing from left to right
  const arrowStyle = {
    position: "absolute",
    right: "-10px",
    top: "50%",
    transform: "translateY(-50%)",
    width: 0,
    height: 0,
    borderStyle: "solid",
    borderWidth: "5px 0 5px 10px",
    borderColor: "transparent transparent transparent #f5f5f5",
  };

  const closeButtonStyle = {
    position: "absolute",
    top: "-6px",
    left: "-6px",
    backgroundColor: "red",
    color: "white",
    width: "15px",
    height: "15px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    fontSize: "12px",
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5, x: -10 }}
      animate={{ opacity: 1, scale: 1, x: 0 }}
      exit={{ opacity: 0, scale: 0.5, x: -10 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      style={tooltipStyles}
    >
      <Paper
        elevation={5}
        style={{
          padding: "10px 14px",
          display: "flex",
          alignItems: "center",
          borderRadius: "8px",
          background: "#0288d1",
          color: "#fff",
          position: "relative",
        }}
      >
        <Typography variant="subtitle2" style={{ flexGrow: 1 }}>
          {message}
        </Typography>
        <div style={closeButtonStyle} onClick={onClose}>
          <CloseIcon style={{ fontSize: "12px" }} />
        </div>
        <div style={arrowStyle}></div>
      </Paper>
    </motion.div>
  );
};

export default InstructionTooltip;
